import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';
import {AppSettings} from '../app-settings';
import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class CardService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getCards(userId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/card/get",{
    params : {
     userId:userId
    }
   }).map(response => response.json().cards);
  }

  findCard(cardId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/card/find",{
    params : {
     id:cardId
    }
   }).map(response => response.json().card);
  }

  saveCard(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/card/"+(params.id?'edit':'add'), params, this.options).map(response => response.json());
  }

  deleteCard(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/card/delete", params, this.options).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/card.service.ts